import Login from '@/views/Public/Pages/Login.vue'
import SendLink from '@/views/Public/Pages/PasswordReset/SendLink'
import ChangePassword from '@/views/Public/Pages/PasswordReset/ChangePassword'
import Forbidden from '@/views/Public/Pages/Forbidden.vue'

export default [
  {
    path: '/',
    name: 'public-home',
    redirect: 'login'
  },
  {
    path: 'login',
    name: 'public-login',
    component: Login
  },
  {
    path: 'password/reset',
    component: SendLink
  },
  {
    path: 'password/reset/:token',
    component: ChangePassword
  },
  {
    path: 'forbidden',
    name: 'forbidden',
    component: Forbidden
  },
  {
    path: '*',
    redirect: '/login'
  }
]
